import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  label: {
    marginBottom: 5,
    color: custom.grey[2],
    fontSize: 13,
    transform: 'scale(0.92)',
  },
  wrapper: {
    display: 'inline-block',
  },
  tooltip: {
    fontSize: 13,
    backgroundColor: '#fff',
    color: custom.grey[2],
    padding: '15px 10px',
    border: `solid 1px ${custom.grey[14]}`,
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.05)',
  },
  arrow: {
    color: '#fff',
    '&::before': {
      border: `solid 1px ${custom.grey[14]}`,
    },
  },
  item: {
    marginRight: 10,
    marginBottom: 5,
  },
  selectBoxRoot: {
    padding: 0,
    border: 0,
    '& > span': {
      marginTop: 1,
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  selectItemMoreFilters: {
    fontWeight: 500,
    marginBottom: 7,
  },
}));
